module.exports = require('scryptsy')



//////////////////
// WEBPACK FOOTER
// ./~/scrypt.js/js.js
// module id = 708
// module chunks = 0